import { DateTime } from "luxon";

export default class Toolbox {
  static FilterExists<T>(arr: (T | null | undefined)[] | null | undefined) {
    return arr?.filter((x): x is T => x !== null && x !== undefined) ?? [];
  }

  static Color = {
    interpolate: (color1: string, color2: string, z: number) => {
      const clampedZ = Math.min(Math.max(z, 0), 1);

      const color1Clamped = color1.substring(1, 7);
      const color2Clamped = color2.substring(1, 7);

      const color1RGB = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i
        .exec(color1Clamped)
        ?.slice(1)
        ?.map((colPart) => parseInt(colPart, 16));
      const color2RGB = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i
        .exec(color2Clamped)
        ?.slice(1)
        ?.map((colPart) => parseInt(colPart, 16));

      if (!color1RGB || !color2RGB) return "#FF00FF";

      const finalRGB = color1RGB.map(
        (c1, i) => (c1 - (c1 - (color2RGB[i] ?? 0)) * clampedZ) | 0,
      );

      return (
        "#" + finalRGB.map((col) => col.toString(16).padStart(2, "0")).join("")
      );
    },
  };

  static Date = {
    getRelativeDateTime: (date: string, alwaysShowTime?: boolean) => {
      const dt = DateTime.fromISO(date);

      if (dt.toMillis() < DateTime.now().plus({ day: -2 }).toMillis()) {
        return `${dt.toFormat(`d/M/yyyy${alwaysShowTime ? ` - h:mm a` : ""}`)}`;
      }

      const day = dt.toRelativeCalendar();

      const time = dt.toFormat(`h:mm a`);

      return `${day?.split("").reduce((z, x, i) => `${z}${i === 0 ? x.toUpperCase() : x}`, "")} at ${time}`;
    },
  };

  static UUIDv4 = () =>
    `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c) =>
      (c === `x`
        ? (Math.random() * 16) | 0
        : (((Math.random() * 16) | 0) & 0x3) | 0x8
      ).toString(16),
    );

  static sigmoid = (z: number, k = 2) => (1 / (1 + Math.exp(-z / k))) * 2 - 1;
}
